import React from 'react';
import PropTypes from 'prop-types';
import {List, Subheader, Divider, Paper} from 'material-ui';
import Loading from "../../common/Loading/Loading";
import Error from "../../common/Error/Error";
import Type from '../Type/Type';
import style from "../../../styles/styles";
import withTranslation from "../../../hoc/withTranslation";

class DumbTypeList extends React.Component {

    static propTypes = {
        title: PropTypes.string
    };

    static defaultProps = {
        loading: false,
        types: []
    };

    // Render

    render() {
        const {loading, types, title, app} = this.props;

        let content;

        if (loading) {
            content = <Loading paper={false}/>;
        } else if (types.length === 0) {
            content =
                <Error
                    title={this.props.t('generic.no_data')}
                    subtitle={this.props.t('generic.add_some_element')}
                />
        } else {
            content = types.map((type, index) => {
                return (
                    <div key={type.id}>
                        <Type
                            app={app}
                            type={type}
                        />
                        {index !== (types.length - 1) && <Divider inset={true}/>}
                    </div>
                )
            })
        }

        return (
            <div>
                <Paper>
                    <List>
                        <Subheader style={style.subHeader}>
                            {title}
                        </Subheader>

                        {content}
                    </List>
                </Paper>
            </div>
        );
    }
}

export default withTranslation(DumbTypeList);



// WEBPACK FOOTER //
// src/components/type/DumbTypeList/DumbTypeList.js